import { useRef, useState } from "react"
import { getUser, setUser, useHub } from "../../../core/Global"
import { Drawer, DrawerRef } from "../../../components/drawers/Drawer"
import Form from "../../../components/form/Form"
import Icon from "../../../components/base/Icon"
import { toastSuccess } from "../../../components/base/Toast"
import DropDown from "../../../components/form/DropDown"
import { API_ROUTES } from "../../../core/Constants"



interface IProps {
    onClose: () => void
}
export default function AccountEditTimezoneMobile(props: IProps) {

    const hub = useHub()
    const drawer = useRef<DrawerRef>(null)
    const user = getUser()
    const [working, workingSet] = useState<boolean>(false)

    return (
        <Drawer ref={drawer} title="Timezone"
            onClose={props.onClose}>
            <Form id="user-edit-form-mobile" className="form"
                onSubmit={(body, callback) => {

                    workingSet(true);

                    setTimeout(() => {

                        hub.Post("/accounts/users/timezone/" + user?.id, body, res => {
                            if (res.success) {
                                setUser(res.data)
                                drawer.current?.close()
                            }
                            if (callback) callback(res);
                            workingSet(false);
                        });

                    }, 500);



                }}>


                <DropDown id="drp-update-timezones" name="timezone" label="Timezone" marginBottom={10}
                    apiSource={API_ROUTES.Users + "timezones"} defaultValue={user?.timeZoneId}
                    onApiSourceFetched={(data) => {
                        var ofs = window.getClientTimeZoneOffset();
                        var tz = window.getClientTimeZone()?.toLowerCase();
                        var tzArr = tz.split("/");
                        var cityName = tzArr.length > 1 ? tzArr[1] : tzArr[0];

                        var id = "";

                        if (data && data.length > 0) {
                            for (var i = 0; i < data.length; i++) {
                                if (data[i].offset == ofs && data[i].name.toLowerCase().indexOf(cityName) > -1) {
                                    id = data[i].id;
                                    break;
                                }
                            }

                            if (id == "") {
                                for (var i = 0; i < data.length; i++) {
                                    if (data[i].offset == ofs) {
                                        id = data[i].id;
                                        break;
                                    }
                                }
                            }
                        }

                        if (id == "") id = "UTC";
                    }} />


                <button type="submit" className="btn btn-primary w-100 mb-3">
                    {
                        working ?
                            <>
                                <Icon icon="spinner-third" spin />
                                <span className="ms-2">Updating...</span>
                            </>
                            :
                            <>Update Timezone</>
                    }
                </button>

                <button type="button" className="btn btn-secondary w-100 mb-10"
                    onClick={e => drawer.current?.close()}>
                    Discard
                </button>

            </Form>
        </Drawer>
    )

}